module.exports = __webpack_public_path__ + "static/media/hyundai-plus.5ee8025e.svg";